<template>
  <!-- 水表区域配置 -->
  <div class="apphome">
    <div class="apphome_box">
      <div class="search">
        <span style="font-size:16px">区域配置</span>
        <el-button type="primary" @click="add_ed(0)" class="last-el-button">添加顶级区域</el-button>
      </div>
      <el-table id="demo" :max-height="heights" :data="tableData" border style="width: 100%" row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column type="index" label="序号" width="90" align="center">
        </el-table-column>
        <el-table-column label="名称" align="left" min-width="150">
          <template slot-scope="{row}">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(item,index) in columnsMenu" :key="index" :prop="item.key" :label="item.name">
        </el-table-column>

        <el-table-column label="操作" align="center" width="510">
          <template #default="{row}">
            <div class="btnssss" style="display: flex;justify-content: center; align-items: center;">
              <div @click="add_ed(row.id)" class="mr-20">
                <el-tooltip class="item" effect="dark" content="添加子区域" placement="top">
                  <elIconBtn btnType='add'></elIconBtn>
                </el-tooltip>
              </div>
              <div @click="edit_ed(row)" class="mr-20">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                  <elIconBtn btnType='edit'></elIconBtn>
                </el-tooltip>
              </div>
              <div @click="delete_fn(row)">
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <elIconBtn btnType='del'></elIconBtn>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span class="paginationed" style="margin-top:10px">
        <!-- <pagination align="center" :total="total" :page-sizes="[5, 10, 15, 20, total]"
          :page.sync="listData.page" :limit.sync="listData.Rows" @pagination="getList" /> -->
      </span>
    </div>


    <!-- 新增修改菜单 -->
    <el-dialog :title="textMapMenu[dialogStatusMenu]" :close-on-click-modal='false' v-dialogDrag
      :visible.sync="dialogVisibleMenu" width="400" center>
      <el-form :model="tempMenu" :rules="rulesMenu" ref="tempMenu" label-width="120px" class="demo-temp">
        <el-form-item label="名称:" prop="name">
          <el-input v-model="tempMenu.name"></el-input>
        </el-form-item>
        <el-form-item label="区域编码:" prop="code">
          <el-input v-model="tempMenu.code"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisibleMenu = false">取 消</el-button>
          <el-button type="primary" @click="dialogStatusMenu==='edit'?edit_fn('tempMenu'):add_fn('tempMenu')">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>



  </div>
</template>
<script>
  //   import { EnergyArea, EnergyAreaId, EnergyAreaAdd, EnergyAreaDelete, EnergyAreaEdit, GetIdAndNames, GetEnergyAreaOrganization, SaveEnergyAreaOrganization } from "@/utils/request";
  //   import request from "@/utils/request";
  //   import { parseTime } from "@/utils";
  import Pagination from "../../components/module/Pagination"; // 分页
  import {areaFindArea,areaSaveArea,areaDeleteArea} from "../../api/energySubArea";
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {Pagination,elIconBtn},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-220,//屏幕高度 - 导航栏高度
        loading: false,
        data: [],
        total: 0,
        list: '',
        tempMenu: {},
        dialogStatusMenu: '',
        textMapMenu: {
          add: "新增",
          edit: "修改"
        },
        tableData: [],
        heights: document.body.clientHeight-18,
        dialogVisibleMenu: false,
        rulesMenu: {
          name: [
            {required: true,message: '请输入名称',trigger: 'blur'}
          ],

          code: [
            {required: true,message: '请输入编码',trigger: 'blur'}
          ],

        },
        topLevel: 0,//判断是否顶级
        options: [],
        listData: {
          "Page": 1,
          "Rows": 10,
        },

        mainId: '',
        columnsMenu: [{
          name: "区域编码",
          key: "code",
          width: 200,
        }],
      };
    },
    mounted () {
      this.getList();//获取列表数据   
    },
    watch: {

    },

    computed: {

    },
    methods: {

      // 删除区域
      delete_fn (row) {
        this.$confirm(`是否删除 ${row.name}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          areaDeleteArea({"id": row.id}).then(res => {
            if(res.code==200) {
              this.getList();
              var flag=this.$store.unitStore.state.buildingNum
              this.$store.unitStore.commit("setBuildingNum",!flag)
              this.$store.unitStore.commit("getAreaTree")

              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error('删除失败');

            }
          })
        }).catch(() => {
          // ...
        });

      },
      // 确认添加菜单
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            var d={
              "code": this.tempMenu.code,
              "name": this.tempMenu.name,
              "uid": "",
              "upId": this.topLevel
            }

            areaSaveArea(d).then(data => {
              // console.log("添加顶级菜单",data);
              if(data.code==200) {
                this.getList();
                this.dialogVisibleMenu=false;
                var flag=this.$store.unitStore.state.buildingNum
                this.$store.unitStore.commit("setBuildingNum",!flag)
                this.$message({showClose: true,message: '添加成功',type: 'success'});
                this.$store.unitStore.commit("getAreaTree")
              } else {
                this.$message.error(`添加失败，${data.message}`);
              }

            })
          } else {
            return false;
          }
        });
      },
      // 添加菜单弹窗
      add_ed (v) {
        this.dialogStatusMenu='add';
        this.dialogVisibleMenu=true;
        this.topLevel=v
        // console.log(v);
        this.$nextTick(() => {
          this.$refs["tempMenu"].clearValidate();
        });
        this.tempMenu={UpId: v||null};
      },
      // 确认菜单编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            //  console.log(this.tempMenu);
            // delete this.tempMenu.children;
            var d={
              "code": this.tempMenu.code,
              "name": this.tempMenu.name,
              "uid": this.tempMenu.id,
              "upId": this.tempMenu.upId
            }
            areaSaveArea(d).then(data => {
              if(data.code==200) {
                this.getList();
                this.dialogVisibleMenu=false;
                var flag=this.$store.unitStore.state.buildingNum
                this.$store.unitStore.commit("setBuildingNum",!flag)
                this.$message({showClose: true,message: '修改成功',type: 'success'});
                this.$store.unitStore.commit("getAreaTree")
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }

            })

          } else {
            return false;
          }
        });
      },
      //编辑菜单弹窗
      edit_ed (v) {
        this.dialogStatusMenu='edit';
        this.tempMenu=Object.assign({},v);
        this.dialogVisibleMenu=true;
        this.$nextTick(() => {
          this.$refs["tempMenu"].clearValidate();
        });

      },
      //获取列表数据
      getList () {
        this.loading=true;
        areaFindArea().then(res => {
          this.loading=false;
          var data=res.data
          // data =  JSON.parse(JSON.stringify(res.data).replace(/energyAreaVos/g, 'children').replace(/code/g, 'Code').replace(/id/g, 'Id').replace(/name/g, 'Name').replace(/unitId/g, 'OrganizationId'))
          data=JSON.parse(JSON.stringify(res.data).replace(/energyAreaVos/g,'children'))
          this.tableData=data.children
          console.log("tableData",this.tableData);

        })


      }
    }
  };
</script>
<style lang="scss">
  .select_tree {
    .el-tree-node {
      .is-leaf+.el-checkbox .el-checkbox__inner {
        display: inline-block;
      }

      .el-checkbox__input>.el-checkbox__inner {
        display: none;
      }
    }

  }
</style>
<style lang="scss" scoped>
  /deep/.el-dialog {
    margin-top: 3vh !important;
  }

  #demo {
    button {
      font-weight: bold;
      // font-size:18px
      color: #409EFF;
    }

    .line {
      display: inline-block;
      width: 1px;
      height: 20px;
      background-color: #E6E6E6;
      margin: 0px 20px;
    }

    .buttoned {
      cursor: pointer;
    }

    /deep/.el-button span {
      font-size: 15px;
    }
  }



  .apphome_box {
    padding: 20px;
    background-color: #fff;
    box-sizing: border-box;
    height: 100%;
    position: relative;
  }

  .actived {
    color: red;
  }

  .search {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #E6E6E6;
    padding-bottom: 12px;
  }

  .mytable {
    width: 100%;

    /deep/.el-table th {
      background-color: #F1F8FF;
    }
  }

  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 98px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px dashed #d7d7d7;
    border-radius: 4px;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>